import { Markdown } from '@websrc/App/Components/Markdown/Markdown'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { lessonsLandingPage_searchLessons_hits_hit } from '@websrc/Typings/Dante/lessonsLandingPage'
import { hoverShadow } from 'leds'
import React, { FC } from 'react'

import * as SC from './LessonCard.style'

export const LessonCard: FC<
  lessonsLandingPage_searchLessons_hits_hit & { onClick?: () => void }
> = ({
  url,
  title,
  description,
  subjects,
  imageUrl,
  level,
  unitPlanTitle,
  duration,
  grades,
  product,
  isHybrid,
  index,
  onClick,
}) => {
  const t = useStaticText()

  return (
    <SC.GridColWrapper giant={4} tablet={6} veryGiant={3}>
      <SC.Wrapper className={hoverShadow} onClick={onClick} to={url}>
        {isHybrid && <SC.HybridLabel text={t.plans_lessons_worksheets.hybrid} />}
        <SC.ImageContainer>
          {imageUrl && (
            <SC.StyledAsset
              fit={'bounds'}
              sizes={'450px'}
              srcSetWidths={[450]}
              thumbnail={{ url: imageUrl, title }}
              video={undefined}
            />
          )}
          <SC.ImageCaption>
            {t.plans_lessons_worksheets.lesson_number
              .replace('{0}', unitPlanTitle ?? '')
              .replace('{1}', index.toString())}
          </SC.ImageCaption>
        </SC.ImageContainer>
        <SC.DetailsWrapper>
          <SC.Title>{title}</SC.Title>
          <SC.Product>{product.map((p) => p.value).join(', ')}</SC.Product>
          {description && <Markdown markdown={description} />}
          {subjects && <SC.LessonTags>{subjects.map((s) => s.value).join(', ')}</SC.LessonTags>}
          <SC.InfoWrapper>
            {duration && <SC.InfoItem>{duration}</SC.InfoItem>}
            {level && <SC.InfoItem>{level}</SC.InfoItem>}
            {grades && <SC.InfoItem>{grades.value}</SC.InfoItem>}
          </SC.InfoWrapper>
        </SC.DetailsWrapper>
      </SC.Wrapper>
    </SC.GridColWrapper>
  )
}
